import { GridAutoFill } from '@/components/Grid';
import { useModal } from '@/hooks/useModal';
import { usePrefetchQuery } from '@/hooks/usePrefetchQuery';
import { type AdImageType, type AdItemType } from '@/resource/ad';
import styles from './AdImage.module.scss';

export function AdImageGallery({
  ad,
  images,
}: {
  ad: AdItemType;
  images: AdImageType[];
}) {
  return (
    <GridAutoFill minColumnWidth={140}>
      {images.map((image, index) => (
        <AdImage
          key={image.id}
          ad={ad}
          image={image}
          images={images}
          index={index}
        />
      ))}
    </GridAutoFill>
  );
}

export function AdImage({
  ad,
  image,
  images,
  index,
}: {
  ad: AdItemType;
  image: AdImageType;
  images: AdImageType[];
  index: number;
}) {
  const modal = useModal();
  const crop = image.crop['16:9'];
  const src = image.resize['1200_1200'];
  const label = ad.type === 'offer' ? 'Aanbod' : 'Vraag';
  const name = ad.profile.data.first_name;

  const ref = usePrefetchQuery<HTMLAnchorElement>(() => {
    const img = new Image();
    img.src = src;
  });

  return (
    <a
      ref={ref}
      className={styles.Image}
      href={src}
      title={`Foto ${index + 1}`}
      onClick={(e) => {
        e.preventDefault();
        modal.open(
          {
            type: 'image_gallery',
            maxWidth: 92,
            props: {
              title: `${label} van ${name}`,
              initialIndex: index,
              images,
            },
          },
          () => ref.current?.focus()
        );
      }}
    >
      <img
        src={crop[286]}
        srcSet={`${crop[286]} 1x, ${crop[572]} 2x`}
        alt=""
        loading="lazy"
      />
    </a>
  );
}
